import React from 'react'
import { sanityImageUrl } from '../../../utils/helpers'
import cx from 'classnames'
import styles from './style.module.sass'

export default ({ warranty }) => (
  <div className={cx(styles.warranty, {
    [styles.warrantyWhite]: warranty.isWhite
  })}>
    <div className={styles.wrap}>
      <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: warranty.title }} />
      <p className={styles.text}>{warranty.text}</p>
    </div>
  </div>    
)